
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexKJ1R1xNScq5q01fnFR4eYv94vMS3tCBoIDjyLWvrI74Meta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/index.vue?macro=true";
import { default as DashboardUalCzteHK5XCKeXqRrSnK_0yLSRgCYFhRViEN13bqLcMeta } from "/builds/macys/polaris/nuxt-app/my-account/app/pages/Dashboard.vue?macro=true";
import { default as indexW3G286QD0LET2Agr7yV4r_tYNbodwjOOo71CAK9KspcMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/index.vue?macro=true";
import { default as NoSessionCookiebB1nl5d6evt6_twfjFAOB4xHmNhcq1qgc16rXqWrtaYMeta } from "/builds/macys/polaris/nuxt-app/my-account/app/pages/NoSessionCookie.vue?macro=true";
import { default as indexuUqtAQZFpmYj770A2Z8eartqNUItyCY1frTiNWwRq7AMeta } from "/builds/macys/polaris/nuxt-app/my-account/app/pages/VgcVerifyEmail/index.vue?macro=true";
import { default as indexol0OXRWOgn08v99SJM_quXY0LDJBPrJ_E2yzighYAfAMeta } from "/builds/macys/polaris/nuxt-app/my-account/app/pages/GiftCardBalance/index.vue?macro=true";
import { default as ManageAutoReplenishmentG2KGP2VmflO2aCnB4NdE_9RhCBp9o0cKhnWszxSSb_cMeta } from "/builds/macys/polaris/nuxt-app/my-account/app/pages/ManageAutoReplenishment.vue?macro=true";
import { default as indexITr3IqZd2LdB_eNMzh2U_IU7Oa5_f_wbhaya2EjMNWoMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/index.vue?macro=true";
import { default as redemption09iY0OQSiO8uxUb3_hxA9pTBMItucBfdXFbaHgWa2_4Meta } from "/builds/macys/polaris/nuxt-app/my-account/app/pages/VgcVerifyEmail/redemption.vue?macro=true";
import { default as indexPmJ2PsEZN9x9Vu1QNUgu9Xp2cLMfPg24hFOe6LXsN6QMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/amex-offers/index.vue?macro=true";
import { default as verify_45emailAQ0mGs1s0ShEv74YEhNGVIpuxDMNJFn0FtvdckQE_gUMeta } from "/builds/macys/polaris/nuxt-app/my-account/app/pages/VgcVerifyEmail/verify-email.vue?macro=true";
import { default as _91id_93G5HWyULO1tUNs6S9KvAGTdLGJ6aNRMzzTLyvYnOYJwMMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/cards/[id].vue?macro=true";
import { default as indexdDwnxRMuMqBoiurg5bVezUM3XXYz3HqzCOQu98b125wMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/error/index.vue?macro=true";
import { default as index_CgilNrt70XriV38T_JyVPKn_5l3FqdTVb41zwq_ubAMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/guest/index.vue?macro=true";
import { default as index2WQ84BkKOML9YNHuWhWHPzRCQZ7tkyfKvRq1QBWw0OsMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/walletload/index.vue?macro=true";
import { default as balance_45lookup_45formW138rmFlnVTqmxYJbLc8ZxWw2j9EUTfEe_pDbx6UM6UMeta } from "/builds/macys/polaris/nuxt-app/my-account/app/pages/GiftCardBalance/balance-lookup-form.vue?macro=true";
import { default as index3ozobitmILiiP6p5R15RDfQ27D_QqOeQ3KLvN1FTGDQMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/credit-down/index.vue?macro=true";
import { default as _91id_93zCexssCr6cVTA3UQecLbkZam0XOkVKcfJUCsDLrnnJ0Meta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/make-payment/[id].vue?macro=true";
import { default as terms_45and_45conditions6M5VU0mt0P7x1UvZSaiv0R9aExloVI6ilucIhD61qnEMeta } from "/builds/macys/polaris/nuxt-app/my-account/app/pages/GiftCardBalance/terms-and-conditions.vue?macro=true";
import { default as indexU7t3VLX3Lt0xMUc0EfO7YdaWyTeZuq1nZ6z07sBnquoMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/celebratory-message/index.vue?macro=true";
import { default as confirmationHo54SaDDel0sYxec7WvSKiO0SNixcL18qZllj4RmVpYMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/make-payment/confirmation.vue?macro=true";
import { default as _91id_93wa1vLizme7Kxrxif33MPkfrb7UCjakjKPIC3NFgakocMeta } from "/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/make-payment/authorize/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexKJ1R1xNScq5q01fnFR4eYv94vMS3tCBoIDjyLWvrI74Meta || {},
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/index.vue")
  },
  {
    name: "Dashboard",
    path: "/Dashboard",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/app/pages/Dashboard.vue")
  },
  {
    name: "my-credit",
    path: "/my-credit",
    meta: indexW3G286QD0LET2Agr7yV4r_tYNbodwjOOo71CAK9KspcMeta || {},
    redirect: "/my-credit/gateway",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/index.vue")
  },
  {
    name: "NoSessionCookie",
    path: "/NoSessionCookie",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/app/pages/NoSessionCookie.vue")
  },
  {
    name: "VgcVerifyEmail",
    path: "/VgcVerifyEmail",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/app/pages/VgcVerifyEmail/index.vue")
  },
  {
    name: "GiftCardBalance",
    path: "/GiftCardBalance",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/app/pages/GiftCardBalance/index.vue")
  },
  {
    name: "ManageAutoReplenishment",
    path: "/ManageAutoReplenishment",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/app/pages/ManageAutoReplenishment.vue")
  },
  {
    name: "my-credit-gateway",
    path: "/my-credit/gateway",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/index.vue")
  },
  {
    name: "VgcVerifyEmail-redemption",
    path: "/VgcVerifyEmail/redemption",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/app/pages/VgcVerifyEmail/redemption.vue")
  },
  {
    name: "my-credit-amex-offers",
    path: "/my-credit/amex-offers",
    meta: indexPmJ2PsEZN9x9Vu1QNUgu9Xp2cLMfPg24hFOe6LXsN6QMeta || {},
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/amex-offers/index.vue")
  },
  {
    name: "VgcVerifyEmail-verify-email",
    path: "/VgcVerifyEmail/verify-email",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/app/pages/VgcVerifyEmail/verify-email.vue")
  },
  {
    name: "my-credit-gateway-cards-id",
    path: "/my-credit/gateway/cards/:id()",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/cards/[id].vue")
  },
  {
    name: "my-credit-gateway-error",
    path: "/my-credit/gateway/error",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/error/index.vue")
  },
  {
    name: "my-credit-gateway-guest",
    path: "/my-credit/gateway/guest",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/guest/index.vue")
  },
  {
    name: "my-credit-gateway-walletload",
    path: "/my-credit/gateway/walletload",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/walletload/index.vue")
  },
  {
    name: "GiftCardBalance-balance-lookup-form",
    path: "/GiftCardBalance/balance-lookup-form",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/app/pages/GiftCardBalance/balance-lookup-form.vue")
  },
  {
    name: "my-credit-gateway-credit-down",
    path: "/my-credit/gateway/credit-down",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/credit-down/index.vue")
  },
  {
    name: "my-credit-gateway-make-payment-id",
    path: "/my-credit/gateway/make-payment/:id()",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/make-payment/[id].vue")
  },
  {
    name: "GiftCardBalance-terms-and-conditions",
    path: "/GiftCardBalance/terms-and-conditions",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/app/pages/GiftCardBalance/terms-and-conditions.vue")
  },
  {
    name: "my-credit-gateway-celebratory-message",
    path: "/my-credit/gateway/celebratory-message",
    meta: indexU7t3VLX3Lt0xMUc0EfO7YdaWyTeZuq1nZ6z07sBnquoMeta || {},
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/celebratory-message/index.vue")
  },
  {
    name: "my-credit-gateway-make-payment-confirmation",
    path: "/my-credit/gateway/make-payment/confirmation",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/make-payment/confirmation.vue")
  },
  {
    name: "my-credit-gateway-make-payment-authorize-id",
    path: "/my-credit/gateway/make-payment/authorize/:id()",
    component: () => import("/builds/macys/polaris/nuxt-app/my-account/node_modules/@nuxt-common/credit-gateway/app/pages/my-credit/gateway/make-payment/authorize/[id].vue")
  }
]